import type { FC } from 'react';

import { useTranslation } from '@crehana/i18n';
import Trash from '@crehana/icons/Trash';
import {
  colors,
  Dialog,
  DialogContent,
  InverseButton,
  PrimaryButton,
  // biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
} from '@crehana/ui';

const { blueLighter, grayMain } = colors;

interface DeleteCourseDialogProps {
  open: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
  isDark?: boolean;
  title: string;
  description: string;
  cancelButton: string;
  confirmButton: string;
}

const DeleteCourseDialog: FC<
  React.PropsWithChildren<DeleteCourseDialogProps>
> = ({
  open,
  onDismiss,
  onConfirm,
  isDark,
  title,
  description,
  cancelButton,
  confirmButton,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onDismiss={onDismiss}
      isDark={isDark}
      size="s"
      css={{ position: 'absolute', maxWidth: 550, top: 'calc(50% - 172px)' }}
    >
      <DialogContent
        type="s"
        isDark={isDark}
        mainTitle={
          <div className="flex flex-col align-center">
            <div className="flex justify-center items-center pb-12">
              <Trash color={isDark ? blueLighter : grayMain} size={48} />
            </div>{' '}
            <p className="font-h4">{t(title)}</p>
          </div>
        }
        body={t(description)}
        cancelAction={
          <InverseButton
            isGray
            size="m"
            label={t(cancelButton)}
            onClick={onDismiss}
            isDark={isDark}
          />
        }
        confirmAction={
          <PrimaryButton
            size="m"
            className="bg-red-main hover:bg-red-light"
            label={t(confirmButton)}
            onClick={onConfirm}
            isDark={isDark}
          />
        }
      />
    </Dialog>
  );
};

export default DeleteCourseDialog;
